import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";

// Public
import PublicLayout from "@/components/layout/PublicLayout";
import Home from "@/pages/public/Home";
import About from "@/pages/public/About";
import Services from "@/pages/public/Services";
import Bookstore from "@/pages/public/Bookstore";
import BookDetail from "@/pages/public/BookDetail";
import Authors from "@/pages/public/Authors";
import AuthorDetail from "@/pages/public/AuthorDetail";
import Blog from "@/pages/public/Blog";
import BlogPost from "@/pages/public/BlogPost";
import Events from "@/pages/public/Events";
import Gallery from "@/pages/public/Gallery";
import FAQPage from "@/pages/public/FAQPage";
import Contact from "@/pages/public/Contact";
import DynamicPage from "@/pages/public/DynamicPage";
import UnderConstruction from "@/components/UnderConstruction";

// Admin
import AdminLayout from "@/components/layout/AdminLayout";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminBooks from "@/pages/admin/AdminBooks";
import AdminAuthors from "@/pages/admin/AdminAuthors";
import AdminServices from "@/pages/admin/AdminServices";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminEvents from "@/pages/admin/AdminEvents";
import AdminGallery from "@/pages/admin/AdminGallery";
import AdminTestimonials from "@/pages/admin/AdminTestimonials";
import AdminPartners from "@/pages/admin/AdminPartners";
import AdminFAQ from "@/pages/admin/AdminFAQ";
import AdminBanners from "@/pages/admin/AdminBanners";
import AdminMenus from "@/pages/admin/AdminMenus";
import AdminPages from "@/pages/admin/AdminPages";
import AdminSubmissions from "@/pages/admin/AdminSubmissions";
import AdminSettings from "@/pages/admin/AdminSettings";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SettingsProvider>
          <BrowserRouter>
            <Routes>
              {/* Public site */}
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/quem-somos" element={<About />} />
                <Route path="/servicos" element={<Services />} />
                <Route path="/livraria" element={<Bookstore />} />
                <Route path="/livro/:slug" element={<BookDetail />} />
                <Route path="/autores" element={<Authors />} />
                <Route path="/autor/:slug" element={<AuthorDetail />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/eventos" element={<Events />} />
                <Route path="/galeria" element={<Gallery />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/contato" element={<Contact />} />
                <Route path="/p/:slug" element={<DynamicPage />} />
                <Route path="*" element={<UnderConstruction title="Página não encontrada" />} />
              </Route>

              {/* Admin */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
                <Route index element={<AdminDashboard />} />
                <Route path="books" element={<AdminBooks />} />
                <Route path="authors" element={<AdminAuthors />} />
                <Route path="services" element={<AdminServices />} />
                <Route path="blog" element={<AdminBlog />} />
                <Route path="events" element={<AdminEvents />} />
                <Route path="gallery" element={<AdminGallery />} />
                <Route path="testimonials" element={<AdminTestimonials />} />
                <Route path="partners" element={<AdminPartners />} />
                <Route path="faqs" element={<AdminFAQ />} />
                <Route path="banners" element={<AdminBanners />} />
                <Route path="menus" element={<AdminMenus />} />
                <Route path="pages" element={<AdminPages />} />
                <Route path="submissions" element={<AdminSubmissions />} />
                <Route path="settings" element={<AdminSettings />} />
              </Route>
            </Routes>
            <Toaster
              position="top-right"
              theme="dark"
              toastOptions={{
                style: { background: "#1A1A1A", color: "#FDFBF7", border: "1px solid rgba(197,160,89,0.3)" },
              }}
            />
          </BrowserRouter>
        </SettingsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
